// Vuex Settings module actions
import { API } from '@/config';

import {
  FILL_BUTTON_ICONS_LIST, FILL_WIDGET_ICONS_LIST, FILL_BEHAVIOR_TYPES_LIST,
  FILL_PACKAGE_DEFINITIONS, FILL_FAQ_LIST,
} from './mutations-types';

export default {
  async getButtonIconsList({ commit }) {
    try {
      const buttonIcons = (await API.get('/settings/icons')).data.data;
      commit(FILL_BUTTON_ICONS_LIST, { buttonIcons });
    } catch (error) {
      console.log(error);
    }
  },

  async getWidgetIcons({ commit }) {
    try {
      const widgetIcons = (await API.get('/settings/iconsWidget')).data.data;
      commit(FILL_WIDGET_ICONS_LIST, { widgetIcons });
    } catch (error) {
      console.log(error);
    }
  },

  async getBehaviorTypes({ commit }) {
    try {
      const behaviorTypes = (await API.get('/settings/callBehaviorTypes')).data.data;
      commit(FILL_BEHAVIOR_TYPES_LIST, { behaviorTypes });
    } catch (error) {
      console.log(error);
    }
  },

  async getPackageDefinitions({ commit }) {
    const packageDefinitions = (await API.get('/settings/packageDefinitions')).data.data;
    commit(FILL_PACKAGE_DEFINITIONS, { packageDefinitions });
  },

  async getFaq({ commit }) {
    const faqList = (await API.get('/faq')).data.data;
    commit(FILL_FAQ_LIST, { faqList });
  },
};
